import AwesomePhoneNumber from 'awesome-phonenumber';

// TODO: https://jira.andersenlab.com/browse/UNK-6385 remove the function and use the same function
// from universkin-shared (only solve after we merge questionnaire-new-design with develop branch)
export const parsePhone = (country, number = '') => {
  if (!country) {
    throw Error('Missing required argument "country"');
  }

  const numberParsed = new AwesomePhoneNumber(number, country);
  const significant = numberParsed.getNumber('significant') || number;
  const international = numberParsed.getNumber('international') || '';
  const isValid = numberParsed.isValid();

  const displayValueWithoutCountryCode = international
    .split(' ')
    .slice(1)
    .join(' ');

  return {
    significant,
    displayValueWithoutCountryCode: displayValueWithoutCountryCode || number,
    international,
    isValid
  };
};
